module.exports = __webpack_public_path__ + "img/Safety_Comfort.bfd537a5.jpg";